var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1999 4.80005C3.20615 4.80005 2.3999 5.6063 2.3999 6.60005C2.3999 7.1663 2.66615 7.6988 3.1199 8.04005L10.9199 13.89C11.5612 14.37 12.4387 14.37 13.0799 13.89L20.8799 8.04005C21.3337 7.6988 21.5999 7.1663 21.5999 6.60005C21.5999 5.6063 20.7937 4.80005 19.7999 4.80005H4.1999ZM2.3999 9.75005V16.8C2.3999 18.1238 3.47615 19.2 4.7999 19.2H19.1999C20.5237 19.2 21.5999 18.1238 21.5999 16.8V9.75005L14.1599 15.33C12.8812 16.29 11.1187 16.29 9.8399 15.33L2.3999 9.75005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e6280de33828fe9236157c0c004bfd38.svg";
export { ForwardRef as ReactComponent };